/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A short, fixed limit keeps updates to status and blockers instead of turning into a discussion, which is pushed to a separate meeting. Ten to fifteen minutes is generally enough for a small team to each give a brief update without the meeting dragging on.`)
};

const es_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un límite corto y fijo mantiene las actualizaciones centradas en el estado y los bloqueos, en lugar de convertirse en una discusión, que se traslada a una reunión aparte. De diez a quince minutos generalmente es suficiente para que cada miembro de un equipo pequeño dé una breve actualización sin que la reunión se prolongue.`)
};

const de_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein kurzes, festes Limit hält Updates auf Status und Blocker beschränkt, statt in eine Diskussion abzudriften, die in ein separates Meeting verschoben wird. Zehn bis fünfzehn Minuten reichen meist aus, damit jeder in einem kleinen Team ein kurzes Update geben kann, ohne dass sich das Meeting hinzieht.`)
};

const nl_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een korte, vaste limiet houdt updates beperkt tot status en blokkades in plaats van dat het een discussie wordt, die naar een aparte meeting wordt verplaatst. Tien tot vijftien minuten is over het algemeen genoeg voor een klein team om elk kort een update te geven zonder dat de meeting uitloopt.`)
};

const fr_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une limite courte et fixe recentre les points d’avancement sur le statut et les blocages, au lieu de tourner en discussion, qui est renvoyée à une réunion séparée. Dix à quinze minutes suffisent généralement pour qu’une petite équipe donne chacun un point bref sans que la réunion ne s’éternise.`)
};

const it_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un limite breve e fisso mantiene gli aggiornamenti su stato e blocchi invece di trasformarsi in una discussione, che viene rimandata a una riunione separata. Dieci-quindici minuti sono generalmente sufficienti perché ogni membro di un piccolo team dia un breve aggiornamento senza che la riunione si prolunghi.`)
};

const pt_br2_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um limite curto e fixo mantém as atualizações focadas em status e bloqueios, em vez de se transformarem em uma discussão, que fica reservada para uma reunião separada. De dez a quinze minutos geralmente é suficiente para que cada membro de uma equipe pequena dê uma breve atualização sem que a reunião se arraste.`)
};

const pt_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um limite curto e fixo mantém as atualizações centradas no estado e nos bloqueios, em vez de se transformarem numa discussão, que é remetida para uma reunião separada. Dez a quinze minutos são geralmente suficientes para que cada elemento de uma equipa pequena dê uma breve atualização sem que a reunião se arraste.`)
};

const ja_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短く固定された制限時間があることで、内容が状況報告や障害事項にとどまり、議論に発展する場合は別のミーティングに回されます。10〜15分は、小規模チームがそれぞれ手短に報告するには一般的に十分な長さで、ミーティングが長引くのを防ぎます。`)
};

const zh_timer_u10m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短暂固定的时间限制能让汇报聚焦于进展和障碍，而不是演变成一场讨论 — 讨论会被推迟到另一场单独的会议中。对于小团队来说，十到十五分钟通常足够每个人做简短汇报，而不会让会议拖沓冗长。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u10m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u10m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u10m_faq4_a", locale)
	if (locale === "en") return en_timer_u10m_faq4_a(inputs)
	if (locale === "es") return es_timer_u10m_faq4_a(inputs)
	if (locale === "de") return de_timer_u10m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u10m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u10m_faq4_a(inputs)
	if (locale === "it") return it_timer_u10m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u10m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u10m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u10m_faq4_a(inputs)
	return zh_timer_u10m_faq4_a(inputs)
};